import { controls } from "../controls";

const scaleoffinanceagri = {
  label: "Crops Scale of finance",
  pageLabel: "Crops Scale of finance",
  description: "",
  starting: true,
  url: "scaleoffinanceagri",
  formActions: { edit: { allow: true } },
  pageType: "history",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  // filter: [
  //   ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-1" }),
  //   ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, star: true, defaultValue: "assigned_branch" }),
  //   ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2" }),

  //   ...controls.displayText({ tab: "filter", label: "PACS ID", width: "col-sm-1" }),
  //   ...controls.text({ tab: 'create', isReadOnly: 'edit', name: "pacs_id", isRequired: true, star: true }),
  //   ...controls.displayText({ tab: "filter", width: "col-sm-4" }),

  //   ...controls.displayText({ tab: "filter", label: "Account No", width: "col-sm-1" }),
  //   ...controls.AccountNumber({ tab: "filter" }),
  //   ...controls.showData({ tab: "filter", data: "account_number_display", name: "account_number_display", width: "col-sm-2" }),

  //   ...controls.displayText({ tab: "filter", label: "Secretary CIN", width: "col-sm-1" }),
  //   ...controls.customerNumber({ tab: "filter" }),
  //   ...controls.showData({ tab: "filter", data: "customer_number_display", name: "customer_number_display", width: "col-sm-2", displaytype: 'titlecase' }),
  //   ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

  //   ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-1" }),
  //   ...controls.Taluka({ tab: "filter" }),
  //   ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

  //   ...controls.displayText({ tab: "filter", label: "Village", width: "col-sm-1" }),
  //   ...controls.Village({
  //     tab: "filter"
  //   }),
  //   ...controls.showData({ tab: "filter", data: "village_display", name: "village_display", width: "col-sm-2" }),
  // ],

  form: [

    ...controls.displayText({ tab: "create", label: "Parent Branch", width: "col-sm-1" }),
    ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, star: true, defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "PACS ID", width: "col-sm-1" }),
    ...controls.text({ tab: 'create', isReadOnly: 'edit', name: "pacs_id", isRequired: true, star: true }),

    ...controls.displayText({ tab: "create", label: "Exp Limit", width: "col-sm-1" }),
    ...controls.numberOnly({ tab: "create", name: "exposure_limit", width: "col-sm-2", placeHolder: "Limit" }),

    ...controls.button({
      tab: 'create',
      label: "ADD", onclick: {
        action: "appendToHTMLTable",
        tableNameField: 'exposure_limit_table',
        requiredField: ["branch_code", "branch_display", "pacs_id", "pacs_id_name_display", "exposure_limit"]
      }, width: "col-sm-1"
    }),
    {
      tab: 'create',
      inputType: "table",
      tableTitle: "",
      // convertedTo: "nominee_table",
      deletable: true,
      // editable: true,
      // addRows: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "PACS ID", field: "pacs_id" },
        { label: "Name", field: "pacs_id_name_display" },
        { label: "Limit", field: "exposure_limit" }
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "exposure_limit_table"
    }
  ],
  // history: {
  //   perPage: 10,
  //   reportHeader: "Exposure Limit",
  //   pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
  //   clickable: true,
  //   displayColumns: [
  //     {
  //       Header: "Branch",
  //       accessor: "branch_display",
  //       width: 150, type: "small"
  //     },
  //     {
  //       Header: "PACS ID",
  //       accessor: "pacs_id",
  //     },
  //     {
  //       Header: "Taluka",
  //       accessor: "taluka_display",
  //     },
  //     {
  //       Header: "Village",
  //       accessor: "village_display",
  //     },
  //     {
  //       Header: "Limit",
  //       accessor: "limit",
  //     },
  //   ]
  // }
};

export default scaleoffinanceagri;